import styled from "styled-components";

const Btn = styled.button`
  flex: 1;
  min-width: 25%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 0;
  cursor: pointer;
  padding: 8px 4px;
  color: #222;
  font-size: 13px;
`;

const Img = styled.img`
  width: 36px;
  height: 36px;
  object-fit: contain;
`;

const WalletRouterBtn = ({
  onPress,
  imgSrc,
  title,
}: {
  onPress?: () => void;
  imgSrc?: string;
  title?: string;
}) => (
  <Btn type="button" onClick={onPress}>
    {imgSrc ? <Img src={imgSrc} alt={title} /> : null}
    <span>{title}</span>
  </Btn>
);

export default WalletRouterBtn;
